module.exports = __webpack_public_path__ + "img/global.56f035f1.png";